import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { createContext, FC, useCallback, useState } from 'react';

type ActiveTabContextValue = {
  activeTab: number;
  handleTabChange: (newActiveTab: number) => void;
};

type TabsContainerProps = {
  defaultActive?: number;
};

const ActiveTabContext = createContext({} as ActiveTabContextValue);

const StyledBox = styled(Box)(
  ({
    theme: {
      palette: { common },
      spacing,
    },
  }) => ({
    backgroundColor: common.white,
    padding: spacing(2, 3, 3, 3),
  }),
);

const TabsContainer: FC<BoxProps & TabsContainerProps> = ({
  children,
  defaultActive,
}): JSX.Element => {
  const [activeTab, setActiveTab] = useState<number>(defaultActive || 0);

  const handleTabChange = useCallback((newActiveTab: number) => {
    setActiveTab(newActiveTab);
  }, []);

  return (
    <ActiveTabContext.Provider value={{ activeTab, handleTabChange }}>
      <StyledBox>{children}</StyledBox>
    </ActiveTabContext.Provider>
  );
};

export { ActiveTabContext, TabsContainer };
